import React, { FC } from 'react'
import { orderLiveMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import './index.scss'

const PickupWaiter: FC = () => {
  if (!orderLiveMobx.needReorder) return null
  return (
    <div className='cart-status'>
      {i18n.t('newCart.orderHasChanged')}
      <i
        className='iconfont icon-close'
        data-cypid='cartStatusClose'
        onClick={() => {
          orderLiveMobx.setNeedReorder(false)
        }}
      >
      </i>
    </div>
  )
}

export default observer(PickupWaiter)
